/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CommonResponseDto,
  CreateStoryGroupRequestDto,
  DeleteStoryGroupParams,
  DisableStoryGroupRequestDto,
  GetGroupsByPostingIdParams,
  GetStoryGroupListParams,
  HTTPValidationError,
  StoryGroupResponseDto,
  UpdateStoryGroupRequestDto
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 계정에등록된포스팅그룹을가져오는API
 * @summary GetStoryGroupList
 */
export const getStoryGroupList = (
    params?: GetStoryGroupListParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<StoryGroupResponseDto>(
      {url: `/story-group/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetStoryGroupListQueryKey = (params?: GetStoryGroupListParams,) => {
    return [`/story-group/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetStoryGroupListQueryOptions = <TData = Awaited<ReturnType<typeof getStoryGroupList>>, TError = HTTPValidationError>(params?: GetStoryGroupListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoryGroupList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoryGroupListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoryGroupList>>> = ({ signal }) => getStoryGroupList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStoryGroupList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStoryGroupListQueryResult = NonNullable<Awaited<ReturnType<typeof getStoryGroupList>>>
export type GetStoryGroupListQueryError = HTTPValidationError


export function useGetStoryGroupList<TData = Awaited<ReturnType<typeof getStoryGroupList>>, TError = HTTPValidationError>(
 params: undefined |  GetStoryGroupListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoryGroupList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoryGroupList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoryGroupList<TData = Awaited<ReturnType<typeof getStoryGroupList>>, TError = HTTPValidationError>(
 params?: GetStoryGroupListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoryGroupList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoryGroupList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoryGroupList<TData = Awaited<ReturnType<typeof getStoryGroupList>>, TError = HTTPValidationError>(
 params?: GetStoryGroupListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoryGroupList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetStoryGroupList
 */

export function useGetStoryGroupList<TData = Awaited<ReturnType<typeof getStoryGroupList>>, TError = HTTPValidationError>(
 params?: GetStoryGroupListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoryGroupList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStoryGroupListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetStoryGroupListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getStoryGroupList>>, TError = HTTPValidationError>(params?: GetStoryGroupListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoryGroupList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoryGroupListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoryGroupList>>> = ({ signal }) => getStoryGroupList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoryGroupList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStoryGroupListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getStoryGroupList>>>
export type GetStoryGroupListSuspenseQueryError = HTTPValidationError


export function useGetStoryGroupListSuspense<TData = Awaited<ReturnType<typeof getStoryGroupList>>, TError = HTTPValidationError>(
 params: undefined |  GetStoryGroupListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoryGroupList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoryGroupListSuspense<TData = Awaited<ReturnType<typeof getStoryGroupList>>, TError = HTTPValidationError>(
 params?: GetStoryGroupListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoryGroupList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoryGroupListSuspense<TData = Awaited<ReturnType<typeof getStoryGroupList>>, TError = HTTPValidationError>(
 params?: GetStoryGroupListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoryGroupList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetStoryGroupList
 */

export function useGetStoryGroupListSuspense<TData = Awaited<ReturnType<typeof getStoryGroupList>>, TError = HTTPValidationError>(
 params?: GetStoryGroupListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoryGroupList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStoryGroupListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 스토리그룹업데이트API
 * @summary UpdateStoryGroup
 */
export const updateStoryGroup = (
    updateStoryGroupRequestDto: UpdateStoryGroupRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/story-group/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateStoryGroupRequestDto
    },
      options);
    }
  


export const getUpdateStoryGroupMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoryGroup>>, TError,{data: UpdateStoryGroupRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStoryGroup>>, TError,{data: UpdateStoryGroupRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStoryGroup>>, {data: UpdateStoryGroupRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  updateStoryGroup(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateStoryGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateStoryGroup>>>
    export type UpdateStoryGroupMutationBody = UpdateStoryGroupRequestDto
    export type UpdateStoryGroupMutationError = HTTPValidationError

    /**
 * @summary UpdateStoryGroup
 */
export const useUpdateStoryGroup = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoryGroup>>, TError,{data: UpdateStoryGroupRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateStoryGroup>>,
        TError,
        {data: UpdateStoryGroupRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateStoryGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 스토리그룹생성API
 * @summary CreateStoryGroup
 */
export const createStoryGroup = (
    createStoryGroupRequestDto: CreateStoryGroupRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/story-group/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createStoryGroupRequestDto
    },
      options);
    }
  


export const getCreateStoryGroupMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStoryGroup>>, TError,{data: CreateStoryGroupRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof createStoryGroup>>, TError,{data: CreateStoryGroupRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStoryGroup>>, {data: CreateStoryGroupRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  createStoryGroup(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateStoryGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createStoryGroup>>>
    export type CreateStoryGroupMutationBody = CreateStoryGroupRequestDto
    export type CreateStoryGroupMutationError = HTTPValidationError

    /**
 * @summary CreateStoryGroup
 */
export const useCreateStoryGroup = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStoryGroup>>, TError,{data: CreateStoryGroupRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof createStoryGroup>>,
        TError,
        {data: CreateStoryGroupRequestDto},
        TContext
      > => {

      const mutationOptions = getCreateStoryGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 스토리그룹삭제API
 * @summary DeleteStoryGroup
 */
export const deleteStoryGroup = (
    params: DeleteStoryGroupParams,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/story-group/`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteStoryGroupMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStoryGroup>>, TError,{params: DeleteStoryGroupParams}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStoryGroup>>, TError,{params: DeleteStoryGroupParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStoryGroup>>, {params: DeleteStoryGroupParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteStoryGroup(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteStoryGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStoryGroup>>>
    
    export type DeleteStoryGroupMutationError = HTTPValidationError

    /**
 * @summary DeleteStoryGroup
 */
export const useDeleteStoryGroup = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStoryGroup>>, TError,{params: DeleteStoryGroupParams}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteStoryGroup>>,
        TError,
        {params: DeleteStoryGroupParams},
        TContext
      > => {

      const mutationOptions = getDeleteStoryGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 특정포스팅과연관된스토리그룹들을가져오는API
 * @summary GetGroupsByPostingId
 */
export const getGroupsByPostingId = (
    params: GetGroupsByPostingIdParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<StoryGroupResponseDto>(
      {url: `/story-group/story-id`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetGroupsByPostingIdQueryKey = (params: GetGroupsByPostingIdParams,) => {
    return [`/story-group/story-id`, ...(params ? [params]: [])] as const;
    }

    
export const getGetGroupsByPostingIdQueryOptions = <TData = Awaited<ReturnType<typeof getGroupsByPostingId>>, TError = HTTPValidationError>(params: GetGroupsByPostingIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsByPostingId>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupsByPostingIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupsByPostingId>>> = ({ signal }) => getGroupsByPostingId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupsByPostingId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGroupsByPostingIdQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupsByPostingId>>>
export type GetGroupsByPostingIdQueryError = HTTPValidationError


export function useGetGroupsByPostingId<TData = Awaited<ReturnType<typeof getGroupsByPostingId>>, TError = HTTPValidationError>(
 params: GetGroupsByPostingIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsByPostingId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupsByPostingId>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetGroupsByPostingId<TData = Awaited<ReturnType<typeof getGroupsByPostingId>>, TError = HTTPValidationError>(
 params: GetGroupsByPostingIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsByPostingId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupsByPostingId>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetGroupsByPostingId<TData = Awaited<ReturnType<typeof getGroupsByPostingId>>, TError = HTTPValidationError>(
 params: GetGroupsByPostingIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsByPostingId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetGroupsByPostingId
 */

export function useGetGroupsByPostingId<TData = Awaited<ReturnType<typeof getGroupsByPostingId>>, TError = HTTPValidationError>(
 params: GetGroupsByPostingIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsByPostingId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGroupsByPostingIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetGroupsByPostingIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getGroupsByPostingId>>, TError = HTTPValidationError>(params: GetGroupsByPostingIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGroupsByPostingId>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupsByPostingIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupsByPostingId>>> = ({ signal }) => getGroupsByPostingId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGroupsByPostingId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGroupsByPostingIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupsByPostingId>>>
export type GetGroupsByPostingIdSuspenseQueryError = HTTPValidationError


export function useGetGroupsByPostingIdSuspense<TData = Awaited<ReturnType<typeof getGroupsByPostingId>>, TError = HTTPValidationError>(
 params: GetGroupsByPostingIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGroupsByPostingId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetGroupsByPostingIdSuspense<TData = Awaited<ReturnType<typeof getGroupsByPostingId>>, TError = HTTPValidationError>(
 params: GetGroupsByPostingIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGroupsByPostingId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetGroupsByPostingIdSuspense<TData = Awaited<ReturnType<typeof getGroupsByPostingId>>, TError = HTTPValidationError>(
 params: GetGroupsByPostingIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGroupsByPostingId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetGroupsByPostingId
 */

export function useGetGroupsByPostingIdSuspense<TData = Awaited<ReturnType<typeof getGroupsByPostingId>>, TError = HTTPValidationError>(
 params: GetGroupsByPostingIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGroupsByPostingId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGroupsByPostingIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 스토리그룹활성화/비활성화API
 * @summary UpdateStoryGroup
 */
export const disableStoryGroup = (
    groupId: string,
    disableStoryGroupRequestDto: DisableStoryGroupRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/story-group/${groupId}/state`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: disableStoryGroupRequestDto
    },
      options);
    }
  


export const getDisableStoryGroupMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableStoryGroup>>, TError,{groupId: string;data: DisableStoryGroupRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof disableStoryGroup>>, TError,{groupId: string;data: DisableStoryGroupRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableStoryGroup>>, {groupId: string;data: DisableStoryGroupRequestDto}> = (props) => {
          const {groupId,data} = props ?? {};

          return  disableStoryGroup(groupId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DisableStoryGroupMutationResult = NonNullable<Awaited<ReturnType<typeof disableStoryGroup>>>
    export type DisableStoryGroupMutationBody = DisableStoryGroupRequestDto
    export type DisableStoryGroupMutationError = HTTPValidationError

    /**
 * @summary UpdateStoryGroup
 */
export const useDisableStoryGroup = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableStoryGroup>>, TError,{groupId: string;data: DisableStoryGroupRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof disableStoryGroup>>,
        TError,
        {groupId: string;data: DisableStoryGroupRequestDto},
        TContext
      > => {

      const mutationOptions = getDisableStoryGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    